import { apiRoutes } from "@constants/api-routes";
import { RequestTypes } from "@enums/request-types";
import { QueryParameter } from "@idw-types/common";
import { MonthlyUsersResult } from "@idw-types/data/monthly-users-result/monthly-users-result";
import { handleRequestWithQueryParams } from "@utils/http-util";

export const getMonthlyUsersRequest = async (
    queryParameters: Array<QueryParameter>
): Promise<{ data: MonthlyUsersResult, error: any }> => {
    const route = apiRoutes.reports.monthlyUsers.results;

    const { data, error } = await handleRequestWithQueryParams(RequestTypes.GET, route, queryParameters);
    return { data, error };
};